<template>
  <question-card @submit="submit" :disabled='disabled' :buttonText="UIComponentData.Button.Translations[questionnaireLead.Language]">
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-60 md-medium-size-100">
        <v-text-field
        autofocus
        outlined
          v-model="downPaymentAmount"
          ref="amount"
          :label="UIComponentData.InputPlaceholder1.Translations[questionnaireLead.Language]"
          required
          type="numeric"
          inputmode="numeric"
      />
      </div>
      <div class="md-layout-item md-size-40 md-medium-size-100">
        <v-text-field
        outlined
          v-model="downPaymentPercent"
          ref="percent"
          :label="UIComponentData.InputPlaceholder2.Translations[questionnaireLead.Language]"
          required
          type="numeric"
          inputmode="decimal"
          />
        <span class="error" v-if="disabled">
          {{UIComponentData.ErrorMessage.Translations[questionnaireLead.Language]}}
        </span>
      </div>
    </div>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import QuestionCard from '@/components/QuestionCard.vue';

export default {
  name: 'down-payment-step',
  components: {
    QuestionCard,
  },
  data: () => ({
      downPaymentAmount: null,
      downPaymentPercent: null,
    }),
  computed: {
    ...mapGetters(['questionnaireLead']),
    disabled() {
      return this.questionnaireLead.PurchasePrice <= this.questionnaireLead.DownPaymentAmount;
    }
  },
  methods: {
    ...mapActions(['mutateLead']),
    async submit() {
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
  created(){
    if(this.questionnaireLead.DownPaymentPercent==null){
      this.$set(this.questionnaireLead, 'DownPaymentPercent','');
    }
    else{
      this.downPaymentPercent=this.questionnaireLead.DownPaymentPercent+'%'
    }
    if(this.questionnaireLead.DownPaymentAmount==null){
      this.$set(this.questionnaireLead, 'DownPaymentAmount','');
    }
    else{
      this.downPaymentAmount='$'+this.questionnaireLead.DownPaymentAmount.toLocaleString('en-US', { style: 'decimal', currency: 'USD' })
    }

  },
  mounted() {
    this.$refs.amount.$el.focus();
  },
  watch: {
    'downPaymentAmount':function(value){
      let amount=value?parseInt(value.replace(/[^0-9]/g, '')):NaN
      if(isNaN(amount)){
        this.questionnaireLead.DownPaymentAmount=null
        this.downPaymentAmount=null
        if(document.activeElement===this.$refs.amount.$el.querySelector('input'))
          this.downPaymentPercent=null
      }
      else{
        if(amount!=this.questionnaireLead.DownPaymentAmount){
          this.questionnaireLead.DownPaymentAmount=amount
          this.downPaymentAmount='$'+amount.toLocaleString('en-US', { style: 'decimal', currency: 'USD' })
          if(document.activeElement===this.$refs.amount.$el.querySelector('input')){
            this.downPaymentPercent=((this.questionnaireLead.DownPaymentAmount / this.questionnaireLead.PurchasePrice) * 100).toFixed(2).toString()
          }
        }
      }
    },
    'downPaymentPercent':function(value){
      let percent=value?parseFloat(value.replace(/[^0-9.]/g, '')):NaN
      if(isNaN(percent)){
        this.questionnaireLead.DownPaymentPercent=null
        this.downPaymentPercent=null
        if(document.activeElement===this.$refs.percent.$el.querySelector('input')){
          this.downPaymentAmount=null
        }
      }
      else{
        if(percent!=this.questionnaireLead.DownPaymentPercent){
          this.questionnaireLead.DownPaymentPercent=percent
          this.downPaymentPercent=percent+'%'
          if(document.activeElement===this.$refs.percent.$el.querySelector('input')){
            this.downPaymentAmount=parseInt(this.questionnaireLead.PurchasePrice * this.questionnaireLead.DownPaymentPercent/100).toString()
          }
        }
      }
    }
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
};
</script>

<style lang="scss" scoped>
.md-layout-item {
  .lg-width-100 {
    @media (min-width: 1280px) {
      width: 132px;
    }
  }
}
</style>
